import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Overlay, Row, Col, Glyphicon } from 'react-bootstrap';
import TextInput from './TextInput';
import Button from './Button';
import TemplatesForm, { EMAIL_SUBTEMPLATES, SMS_SUBTEMPLATES } from '../TemplatesForm';
import QuickUpdatableComponent from './QuickUpdatableComponent';
import AutoComplete from './AutoComplete';


class TemplatesSelect extends QuickUpdatableComponent {
    constructor(props) {
        super(props);
        this.wrapInputField = this.wrapInputField.bind(this);
        this.isDisabled = this.isDisabled.bind(this);
        this.ref = React.createRef();
        this.state = {
            show: false,
            defaultSubdocument: undefined,
            field: {},
            onChange: undefined,
            disabled: false,
        }
    }

    componentDidMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        const subtemplates = [...EMAIL_SUBTEMPLATES, ...SMS_SUBTEMPLATES];
        const field = { ...nextProps.field };
        field.onChange = undefined;
        this.setState({
            field: field,
            defaultSubdocument: nextProps.templatesFieldName && nextProps.templatesFieldName.includes('Email') ?
                subtemplates.find(v => v.value === 'email_templates') :
                subtemplates.find(v => v.value === 'sms_templates')
        });
    }

    isDisabled(disabled) {
        this.setState({ disabled });
    }

    wrapInputField(inputField, inputFieldRef) {        
        return (
            <div>
            {inputField}
            <Overlay
                show={this.state.show}
                target={inputFieldRef.current}
                placement="bottom"
                container={this}
                containerPadding={20}
            >
            <Popover id="document-dropdown"
                     title={(
                         <h6 style={{ padding: 0, margin: 0 }}>
                             Select
                            <Button
                                bsStyle="link"
                                className="close"
                                style={{ float: 'right', padding: 0, marginTop: -7 }}
                                label={(<span aria-hidden="true">×</span>)}
                                disabled={this.state.disabled}
                                onClick={evt => {
                                    evt.preventDefault();
                                    this.setState({ show: !this.state.show });
                                }}
                            />
                         </h6>)}>
                <Row>
                <Col xs={12}>
                <TemplatesForm
                    enabledDocuments={this.props.enabledDocuments || []}
                    defaultSubdocument={this.props.templatesFieldName}
                    onChange={(value) => {
                        this.props.field.onChange(value);
                        this.setState({ show: false });
                    }}
                    filterNameValue={this.state.field.value}
                    uploadDocTemplateOnSelect={this.props.uploadDocTemplateOnSelect}
                    isDisabled={this.isDisabled}
                />
                </Col>
                </Row>
            </Popover>
            </Overlay>
            </div>
        );
    }

    render() {
        let afterAddon = (
            <Button
                icon='trash'
                disabled={this.state.disabled}
                bsStyle="link"
                iconStyle={{ paddingBottom: '5px', marginLeft: 0 }}
                onClick={(evt) => {
                    evt.preventDefault();
                    this.props.field.onChange(undefined);
                    this.setState({ show: false });
                }}
            />
        );

        if (this.props.multiselect) {
            return (
                <AutoComplete
                    {...this.props}
                    multiselect
                    onChange={selected => this.props.field.onChange(selected)}
                    hideDropDown
                    isClearable={false}
                    placeholder=''
                    style={{ paddingBottom: 65, marginRight: -25 }}
                    disabled={this.state.show || this.state.disabled}
                    allowNew={false}
                    field={this.state.field}
                    wrapInputField={this.wrapInputField}
                    onFocus={evt => {
                        if (evt.currentTarget.click) {
                            if (evt.currentTarget.click(evt)) {
                                return;
                            }
                        }
                        this.setState({ show: true });
                    }}
                    afterAddon={afterAddon}
                />
            );
        }

        return (
            <TextInput
                {...this.props}
                disabled={this.state.show || this.state.disabled}
                field={this.state.field}
                wrapInputField={this.wrapInputField}
                onFocus={() => this.setState({ show: true })}
                afterAddon={afterAddon}
            />
        );
    }
};

TemplatesSelect.propTypes = {
    field: PropTypes.object.isRequired,
    templatesFieldName: PropTypes.any.isRequred,
    uploadDocTemplateOnSelect: PropTypes.bool,
};

export default TemplatesSelect;